var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSoundOn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.501.832v18.334a.852.852 0 0 1-.87.834.833.833 0 0 1-.54-.196L6.42 14.998H3.046A2.054 2.054 0 0 1 1 12.914V7.082A2.054 2.054 0 0 1 3.046 5H6.42L12.1.197a.854.854 0 0 1 1.401.635Zm1.361 6.336a.833.833 0 0 0-.372 1.119 4.25 4.25 0 0 1 0 3.421.834.834 0 0 0 1.49.746 5.92 5.92 0 0 0 0-4.912.834.834 0 0 0-1.118-.374Zm3.44-2.127a.834.834 0 0 0-1.491.745 10.296 10.296 0 0 1 0 8.422.833.833 0 1 0 1.49.745 11.946 11.946 0 0 0 0-9.912Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSoundOn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sound-on.e32ce1cfe1f619a84f950501c81a391a.svg";